import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'

const animalController = new AnimalController()

export function useCreateProductiveAnimal(scope: string = 'createProductiveAnimal') {
  const { userFarm: farmId } = useAuth()

  return useMutation<any, Error, any>({
    mutationKey: [scope],
    mutationFn: (data: any) => animalController.createProductiveAnimal(farmId!, data)
  })
}
